import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b3549c4a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b3549c4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3549c4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3549c4a')) {
      api.createRecord('b3549c4a', component.options)
    } else {
      api.reload('b3549c4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b3549c4a&scoped=true&", function () {
      api.rerender('b3549c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueImageCropperNew/index.vue"
export default component.exports